import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../../../config/url.config";
import { navigateToSessionExpired } from "../../../utils/sessionExpired";
import { documentsWasUpdatedByUser } from "../../../utils/updatedByUser";
import { getAuthHeader } from "../../../utils/superFetch";

export const handleLtaInspectionLog = (itemIndex, requirementDocuments, setLtaInspectionLog, setUserUploadedLog, ltaVehicleLog) => {
    setLtaInspectionLog(ltaVehicleLog)
    for (let requiredItems of requirementDocuments[itemIndex].requiredItems) {
        if ( requiredItems.value !== "" && requiredItems.itemName === "vehicleLog") {
            setUserUploadedLog(true)
            setLtaInspectionLog(requiredItems.url);
        } 
    }
}

export const updateMemberRequirement = (memberRequirement,setMemberRequirement, itemIndex, itemName, updatedValue, updatedUrl) => {
    let tmpData = {...memberRequirement}
    for (let i = 0 ; i< tmpData.requiredDocuments[itemIndex].requiredItems.length ;i++) {
      if (
        itemName === tmpData.requiredDocuments[itemIndex].requiredItems[i].itemName
      ) {
        if(tmpData.requiredDocuments[itemIndex].requiredItems[i].status === 2 || 
          tmpData.requiredDocuments[itemIndex].requiredItems[i].value !== '') {
          documentsWasUpdatedByUser(`${tmpData.requiredDocuments[itemIndex].item}`)
        }
        tmpData.requiredDocuments[itemIndex].requiredItems[i].value = updatedValue
        tmpData.requiredDocuments[itemIndex].requiredItems[i].url = updatedUrl
        break
      }
    }
    setMemberRequirement(tmpData)
    return
}

export const handelImageUpload = async (file, itemName, item, setLoePicture, setValidation,
     profileid, setUserUploadedLoe, navigate, memberRequirement,setMemberRequirement, itemIndex) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("inputType", "image");
    formData.append("itemName", itemName);
    formData.append("item", item);
    const config = {
        headers: {
          "content-type": "multipart/form-data",
          "upload-document": true,
          ...getAuthHeader(),
        },
    };

    try {
        const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileid}`;
        const res = await axios.post(endpoint, formData, config);
  
        setLoePicture(URL.createObjectURL(file))
        setValidation({ show: false, message: "", class: "" })
        setUserUploadedLoe(true)
        updateMemberRequirement(memberRequirement,setMemberRequirement, itemIndex, itemName, res.data.result.itemValue, res.data.result.url)
        
        
      } catch (err) {
        navigateToSessionExpired(navigate, {
          reason: "lta_vehicle_log_upload_failed",
          source: "handelImageUpload",
          component: "LtaVehicleInspectionLog",
          status: err?.response?.status,
          message: err?.message,
          item,
          itemName,
        });
      }
}

export const handleLtaInspectionLogUpload = async (e, setValidation, setLogPicLoading, setUserUploadedLog,
     itemName, item, profileid, setLtaInspectionLog, navigate, memberRequirement,setMemberRequirement, itemIndex) => {
    let file = e.target.files[0];
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7) {
        setValidation({
            show: true,
            message:
              "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded",
            class: "error-msg",
          });
        return;
    }
    setLogPicLoading(() => true)
    await handelImageUpload(file, itemName, item, setLtaInspectionLog, setValidation,
        profileid, setUserUploadedLog, navigate, memberRequirement,setMemberRequirement, itemIndex)
        setLogPicLoading(() => false)
}